{
  "pairing": {
    "title": "ربط جهاز التابلت",
    "instruction": "أدخل رمز الربط في صفحة أجهزة التابلت لدى الموظف",
    "code": "رمز الربط",
    "waiting": "بانتظار الربط...",
    "networkError": "تعذر الاتصال بالخادم",
    "retry": "إعادة المحاولة"
  },
  "idle": {
    "instruction": "بانتظار عملية من الموظف"
  },
  "connection": {
    "reconnecting": "جاري إعادة الاتصال...",
    "stateFailed": "تعذر تحديث البيانات. جاري المحاولة مرة أخرى..."
  },
  "task": {
    "requiredFieldsNote": "الحقول المطلوبة مميزة بعلامة النجمة",
    "signature": "التوقيع",
    "clearSignature": "إعادة التوقيع",
    "signatureRequired": "التوقيع مطلوب",
    "fieldRequired": "{{field}} مطلوب",
    "tooLong": "{{field}} أطول من المسموح",
    "submit": "تم",
    "submitting": "جاري الإرسال...",
    "continue": "متابعة",
    "cancel": "إلغاء",
    "optional": "اختياري",
    "invalidValue": "القيمة غير صالحة",
    "chooseCountry": "اختر الدولة",
    "chooseOption": "اختر...",
    "noMatch": "لا توجد نتائج",
    "saveFailed": "تعذر حفظ البيانات. لم يتم الإرسال، يرجى المحاولة مرة أخرى.",
    "discardTitle": "تجاهل البيانات المدخلة؟",
    "discardDescription": "ستحذف البيانات والتوقيع ولن يتم إرسالها إلى الموظف.",
    "discard": "تجاهل",
    "keepEditing": "متابعة التعبئة",
    "invalidPhotoFile": "الصورة غير صالحة. اختر صورة أخرى"
  },
  "done": {
    "title": "شكرا لك",
    "instruction": "يرجى انتظار الموظف"
  },
  "camera": {
    "capture": "التقاط صورة",
    "retake": "إعادة الالتقاط",
    "choosePhoto": "اختيار صورة",
    "denied": "تعذر الوصول إلى الكاميرا. اختر صورة من الجهاز بدلا من ذلك",
    "unavailable": "الكاميرا غير متوفرة على هذا الجهاز. اختر صورة من الجهاز بدلا من ذلك",
    "tooLarge": "حجم الصورة أكبر من الحد المسموح به"
  },
  "scanner": {
    "instruction": "وجه الكاميرا نحو الرمز",
    "starting": "جاري تشغيل الكاميرا...",
    "scanning": "جاري البحث عن الرمز...",
    "denied": "تعذر الوصول إلى الكاميرا",
    "unavailable": "الكاميرا غير متوفرة على هذا الجهاز",
    "sending": "جاري الإرسال..."
  },
  "link": {
    "invalid": "انتهى هذا الطلب ولم يعد متاحا.",
    "loadFailed": "تعذر الاتصال بالخادم",
    "retry": "إعادة المحاولة"
  }
}
